import {UseMutationResult} from '@tanstack/react-query';
import {FlexProps} from '@chakra-ui/react';

import {OrderableAnswers, TextAndImageAnswers} from './';
import {useTriviaStore} from '../../state';
import type {SubmitAnswerParams, SubmitAnswerResponse} from '../../types';

export interface AnswersProps extends FlexProps {
  submitAnswerMutation: UseMutationResult<SubmitAnswerResponse, unknown, SubmitAnswerParams, unknown>;
}

export function Answers(props: AnswersProps) {
  const answersType = useTriviaStore((state) => state.currentQuestion?.answers_type!);

  if (answersType === 'ordering') return <OrderableAnswers {...props} />;

  return <TextAndImageAnswers {...props} />;
}
